import axios from "axios";
import store from "@/store";
import router from "@/router";
import { server, apiUrl } from "@/services/constants";

export const checkLogin = async (to, from, next) => {
    try {
        await store.dispatch({ type: "restoreLogin" });
        if (store.state.isLogged) {
            return next();
        }
        else {
            return next("/login");
        }
    } catch (error) {
        return next("/login");
    }
};

export const checkLoginWithRedirect = async (to, from, next) => {
    try {
        await store.dispatch({ type: "restoreLogin" });
        if (store.state.isLogged) {
            return next();
        }
        else {
            return next(`/login?redirect=${window.location.pathname}`);
        }
    } catch (error) {
        return next("/login");
    }
};

const isLoggedIn = async () => {
    let username = localStorage.getItem(server.USERNAME);
    if (username==null || username.toString().trim()=="") {
        return false;
    }
    else {
        return true;
    };
};

async function logoff() {
    localStorage.removeItem(server.USERNAME);
    localStorage.removeItem(server.ACCESS_TOKEN);
    localStorage.removeItem(server.ID_TOKEN);
    localStorage.removeItem(server.REFRESH_TOKEN);
    localStorage.removeItem(server.EXPIRES_IN);
    localStorage.removeItem(server.EXPIRES_TIME);
    localStorage.removeItem(server.USER_INFO);
    router.push("/login", () => {});
};

const getExpireTime = (sec) => {
    const t = new Date();
    if (sec > 0)
        t.setSeconds(t.getSeconds() + sec);
    return parseInt(t / 1000); //utc datetime
}

const getToken = async () => {
    var d1 = localStorage.getItem(server.EXPIRES_TIME) ?? 0;
    if (d1 == null)
        d1 = 0;
    if (d1 > 0) {
        var d2 = getExpireTime(0);
        if (d2 > d1) {
            try {
                let response = await refresh_token();
                // console.log("--- refreshToken ---", d1, d2, response);
                localStorage.setItem(server.ACCESS_TOKEN, response.accessToken);
                localStorage.setItem(server.ID_TOKEN, response.idToken);
                localStorage.setItem(server.EXPIRES_IN, response.expiresIn);
                localStorage.setItem(server.EXPIRES_TIME, getExpireTime(response.expiresIn - 120));
                return response.idToken;
            } catch (error) {
                store.dispatch("doLogout");
            }
        }
    }
    let token = localStorage.getItem(server.ID_TOKEN) ?? "";
    if (token==null || token.toString().trim()=="")
        store.dispatch("doLogout")
    else 
        return token;
};

const getInstanceWithOutToken = async () => {
    const instance = axios.create({
        baseURL: `${apiUrl}`,
        headers: {'Content-Type': `application/json`},
        timeout: 600000
    });
    return instance;
};

const getInstance = async () => {
    const token = await getToken();
    const instance = axios.create({
        baseURL: `${apiUrl}`,
        headers: {
            'Access-Control-Allow-Origin': `*`,
            // 'Authorization': `Bearer ${token}`, 
            'Authorization': `${token}`, 
            'Content-Type': `application/json`
        },
        timeout: 600000
    });
    return instance;
};

const refresh_token = async () => {
    let userCode = localStorage.getItem(server.USERNAME) ?? "";
    let refreshToken = localStorage.getItem(server.REFRESH_TOKEN) ?? "";
    const instance = await getInstanceWithOutToken();
    let payload = {
        "userCode": userCode,
        "refreshToken": refreshToken
    };
    return (
        await instance.post("/refresh_token", payload)
    ).data;
};

const login = async (username, password) => {
    const instance = await getInstanceWithOutToken();
    let payload = {
        "username": username,
        "password": password
    };
    return (
        await instance.post("/sign_in", payload)
    ).data;
};

const refreshUserInfo = async () => {
    let userCode = localStorage.getItem(server.USERNAME) ?? "";
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN) ?? "";
    const instance = await getInstance();
    let payload = {
        "userCode": userCode,
        "accessToken": accessToken
    };
    return (
        await instance.post("/get_user", payload)
    ).data;
};

const getVendorSaleReport = async (sdate, edate) => {
    let userCode = localStorage.getItem(server.USERNAME) ?? "";
    const instance = await getInstance();
    let payload = {
        "suCode": userCode,
        "sdate": sdate,
        "edate": edate
    };
    return (
        await instance.post("/getVendorSaleReport", payload)
    ).data;
};

const getVendorOrderList = async (deliveryStatus, limit = null, last_key = "") => {
    let userCode = localStorage.getItem(server.USERNAME) ?? "";
    const instance = await getInstance();
    let payload = {
        "suCode": userCode,
        "deliveryStatus": deliveryStatus,
        "limit": limit,
        "last_key": last_key
    };
    return (
        await instance.post("/getVendorOrderList", payload)
    ).data;
};

const getVendorDeliveryOnProcess = async () => {
    let userCode = localStorage.getItem(server.USERNAME) ?? "";
    const instance = await getInstance();
    let payload = {
        "suCode": userCode
    };
    return (
        await instance.post("/getVendorDeliveryOnProcess", payload)
    ).data;
};

const updateVendorDeliveryStatus = async (orderId, cprcode, deliveryStatus) => {
    const instance = await getInstance();
    let payload = {
        "orderId": orderId,
        "cprcode": parseInt(cprcode),
        "deliveryStatus": parseInt(deliveryStatus)
    };
    return (
        await instance.post("/updateVendorDeliveryStatus", payload)
    ).data;
};

const updateVendorReceiver = async (orderId, cprcode, receiverName) => {
    const instance = await getInstance();
    let payload = {
        "orderId": orderId,
        "cprcode": parseInt(cprcode),
        "receiverName": receiverName
    };
    return (
        await instance.post("/updateVendorReceiver", payload)
    ).data;
};

export default {
    isLoggedIn,
    logoff,
    login,
    refreshUserInfo,
    getVendorSaleReport,
    getVendorOrderList,
    getVendorDeliveryOnProcess,
    updateVendorDeliveryStatus,
    updateVendorReceiver
};